/**
 * withDisableCheckouts
 * HOC for wrapping the provided component with DisableCheckoutsProvider
 */

import React from 'react'

import DisableCheckoutsProvider from './disable-checkouts-provider'

export default function withDisableCheckouts (WrappedComponent) {
  return function DisableCheckoutsProviderHOC(props) {
    return (
      <DisableCheckoutsProvider>
        <WrappedComponent {...props} />
      </DisableCheckoutsProvider>
    )
  }
}
